<template>
  <v-card class="dialog">
    <v-card-title class="primary">
      <span class="headline" v-if="formType === 'E'"
        >CÁLCULO DO ENDOSSO DE COBRANÇA</span
      >
      <span class="headline" v-else-if="formType === 'CE'"
        >CÁLCULO DO ENDOSSO DE EXCLUSÃO</span
      >
      <span class="headline" v-else-if="formType === 'CS'"
        >CÁLCULO DO ENDOSSO DE SUBSTITUIÇÃO</span
      >
      <span class="headline" v-else>CÁLCULO DA APÓLICE</span>
    </v-card-title>
    <v-card-text class="pb-5 px-4">
      <div grid-list-md>
        <v-layout wrap pb-2>
          <v-flex xs12 sm3 md2>
            <v-text-field
              label="Cobertura Compreensiva Líquido (R$)"
              :value="formatMoney(resultados.totalCoberturaCompensativa)"
              disabled
              required
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 md2>
            <v-text-field
              label="Cobertura RCF Líquido (R$)"
              :value="formatMoney(resultados.totalCoberturaRcf)"
              disabled
              required
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 md2>
            <v-text-field
              label="APP Líquido (R$)"
              :value="formatMoney(resultados.totalAp)"
              disabled
              required
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 md2>
            <v-text-field
              label="Coberturas Adicionais Líquido (R$)"
              :value="formatMoney(resultados.totalCoberturasAdicionais)"
              disabled
              required
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 md2>
            <v-text-field
              label="Serviços Agregados Líquido (R$)"
              :value="formatMoney(resultados.totalServicosAgregados)"
              disabled
              required
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-layout wrap pb-2>
          <v-flex xs12 sm3 md2>
            <v-text-field
              label="Franquia Cobertura Compensativa Casco Total (R$)"
              :value="
                formatMoney(resultados.totalFranquiaCoberturaCompensativa)
              "
              disabled
              required
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 md2>
            <v-text-field
              label="Franquia Cobertura Carroceria Total (R$)"
              :value="formatMoney(resultados.totalFranquiaCoberturaCarroceria)"
              disabled
              required
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 md2>
            <v-text-field
              label="Franquia Cobertura Equipamento Total (R$)"
              :value="
                formatMoney(resultados.totalFranquiaCoberturaEquipamentos)
              "
              disabled
              required
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 md2>
            <v-text-field
              label="Franquia Cobertura Acessórios Total (R$)"
              :value="formatMoney(resultados.totalFranquiaCoberturaAcessorios)"
              disabled
              required
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 md2>
            <v-text-field
              v-if="
                resultados.totalRestituicao > 0 || resultados.totalPremio < 0
              "
              label="Total Restituição (R$)"
              :value="formatMoney(resultados.totalRestituicao || 0)"
              required
              disabled
            />
            <v-text-field
              v-else
              label="Prêmio Total (R$)"
              :value="formatMoney(resultados.totalPremio)"
              required
              disabled
            />
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
        <v-card flat color="transparent" class="pa-3 mb-2" v-if="mostrarCondicoesComerciais">
          <v-layout row wrap>
            <v-flex xs12 sm3 md2>
              <v-select
                label="Condição comercial"
                :items="tipoCondicaoList"
                v-model="idTipoCondicao"
                item-text="titulo"
                item-value="id"
                @change="marcarCondicaoAlterada"
                :disabled="condicoesDesabilitadas || listaCondicaoComercialEspecial.length > 0"
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm3 md2>
              <v-select
                label="Aplic. da Condição"
                :items="idTipoCondicao !== 1 ? aplicCondicaoList : aplicaCondicaoList"
                v-model="idAplicaCondicao"
                item-text="titulo"
                item-value="id"
                @change="marcarCondicaoAlterada"
                :disabled="idTipoCondicao === 1 || condicoesDesabilitadas || listaCondicaoComercialEspecial.length > 0"
              >
              </v-select>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm3 md2>
              <v-text-field
                type="number"
                label="Perc. da Condição (%)"
                v-model="percentualCondicao"
                @input="marcarCondicaoAlterada"
                :disabled="idTipoCondicao === 1 || condicoesDesabilitadas || listaCondicaoComercialEspecial.length > 0"
              >
              </v-text-field>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex xs12 sm3 md2 v-if="!condicoesDesabilitadas">
              <v-btn class="button-custom" @click="adicionarNovaCondicaoComercialEspecial" flat>+ CONDIÇÕES</v-btn>
            </v-flex>
          </v-layout>

          <div v-if="mostrarCamposCondicaoComercialEspecial">
            <v-layout row wrap v-for="(condicaoComercialEspecial, index) in listaCondicaoComercialEspecial" :key="index" style="margin-top:10px;">
              <v-flex xs12 sm3 md2>
                <v-select
                  label="Condição comercial Especial"
                  :items="tipoCondicaoFiltrada"
                  v-model="condicaoComercialEspecial.idTipoCondicao"
                  item-text="titulo"
                  item-value="id"
                  @change="marcarCondicaoAlterada"
                  :disabled="condicoesDesabilitadas"
                >
                </v-select>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm3 md2>
                <v-select
                  label="Aplic. da Condição Especial"
                  :items="aplicCondicaoList"
                  v-model="condicaoComercialEspecial.idAplicaCondicao"
                  item-text="titulo"
                  item-value="id"
                  @change="marcarCondicaoAlterada"
                  :disabled="condicoesDesabilitadas"
                >
                </v-select>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm3 md2>
                <v-text-field
                  type="number"
                  label="Perc. da Condição (%) Especial"
                  v-model="condicaoComercialEspecial.percCondicaoComercial"
                  @input="marcarCondicaoAlterada"
                  :disabled="condicoesDesabilitadas"
                >
                </v-text-field>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm3 md2>
                <v-select
                  v-model="condicaoComercialEspecial.listaIdCategoriaVeiculo"
                  :items="modelosListas.catVeiculoList"
                  placeholder="Selecione uma opção"
                  label="Categoria Veiculo"
                  item-value="id"
                  item-text="titulo"
                  multiple
                  @change="marcarCondicaoAlterada"
                  :disabled="condicoesDesabilitadas"
                >
                  <template v-slot:selection="{ item, index }">
                    <span v-if="index === 0">{{ item.titulo }} </span>
                    <span v-if="index === 1">,&nbsp{{ item.titulo }} &nbsp </span>
                    <span v-if="index === 2">
                      (+{{ condicaoComercialEspecial.listaIdCategoriaVeiculo.length - 2 }} outros)
                    </span>
                    <span></span>
                  </template>
                  <template v-slot:prepend-item>
                    <v-list-tile ripple @click="selecionarTodosItensCategoriaVeiculo(index)">
                      <v-list-tile-action>
                        <v-icon style="color: #00456e" class="material-icons-outlined">
                          {{ iconeSelecionarTodosCategoriaVeiculo(index) }}
                        </v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title>Selecionar todos</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider class="mt-2"></v-divider>
                  </template>
                </v-select>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex>
                <v-btn v-if="!condicoesDesabilitadas" class="btn-remover-condicao-especial" @click="removerCondicaoComercialEspecial(index)" flat>Remover</v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-card>
        <v-layout wrap pb-2>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-flex xs12 sm4 md2>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  label="Data da Primeira Parcela"
                  v-model="textPrimeiraParcela"
                  prepend-icon="event"
                  :disabled="camposDisabled"
                  readonly
                  v-on="on"
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="camposInfoGerais.dataPrimeiraParcela"
                no-title
                scrollable
              >
              </v-date-picker>
            </v-menu>
          </v-flex>

          <v-spacer></v-spacer>
          <v-flex xs12 sm3 md1>
            <v-select
              label="Qtd. de Parcelas"
              v-model="camposInfoGerais.idParcelamento"
              :items="camposInfoGerais.parcelamentoList"
              :disabled="camposDisabled"
              item-text="titulo"
              item-value="id"
              required
            >
            </v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 md3>
            <v-select
              :items="camposInfoGerais.formaPagamentoList"
              v-model="camposInfoGerais.idFormaPagamento"
              label="Formas de Pagamento"
              item-text="titulo"
              item-value="id"
              :disabled="camposDisabled"
              required
            >
            </v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 md2>
            <v-text-field
              v-model="camposInfoGerais.apoliceIof"
              label="IOF (%)"
              required
              :disabled="camposDisabled"
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm3 md1>
            <v-text-field
              label="Comissão (%)"
              required
              v-model="camposInfoGerais.corretagem"
              :disabled="camposDisabled"
            >
            </v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
        </v-layout>
      </div>
    </v-card-text>

    <v-card-actions class="px-4 pb-5">
      <v-btn @click="fechar" flat color="primary">Voltar</v-btn>
      <v-spacer></v-spacer>
      <template v-if="visualizarCamposAcoesCalculos && !ehCorretorParceiro">
        <v-btn
          v-if="mostrarCondicoesComerciais"
          color="cyan"
          dark
          @click="calcular"
          :disabled="isLoadingCalcular || isLoadingSalvar || isLoadingEmitir"
        >
          <span v-if="isLoadingCalcular">Calculando</span>
          <span v-else>Calcular</span>
          <v-progress-circular
            v-if="isLoadingCalcular"
            indeterminate
            size="18"
            color="white"
            class="ml-2"
          />
        </v-btn>
        <v-btn
          class="button-permanecer red"
          @click="processarRecusar"
          flat
          :disabled="isLoadingSalvar || isLoadingEmitir"
        >
          Recusar Cotação
        </v-btn>
        <v-btn class="button-permanecer" @click="salvarCotacao" flat :disabled="isLoadingSalvar || isLoadingEmitir">
          <span v-if="isLoadingSalvar">Salvando</span>
          <span v-else>Salvar Cotação</span>
          <v-progress-circular
            v-if="isLoadingSalvar"
            indeterminate
            size="18"
            color="white"
            class="mr-2"
          />
        </v-btn>

        <v-btn
        v-if="mostrarBotaoContestar"
        class="button-permanecer"
        flat
        :disabled="isLoadingSalvar || isLoadingEmitir || isLoadingContestar"
        @click="abrirDialogContestar"
      >
        <span v-if="isLoadingContestar">Contestando</span>
        <span v-else>Contestar</span>
        <v-progress-circular
          v-if="isLoadingContestar"
          indeterminate
          size="18"
          color="white"
          class="ml-2"
        />
        </v-btn>

        <v-btn
          class="button-permanecer"
          flat
          :disabled="isLoadingSalvar || isLoadingEmitir"
          @click="emitirCotacao"
        >
        <span v-if="isLoadingEmitir">Emitindo</span>
        <span v-else>Emitir Proposta</span>
        <v-progress-circular
          v-if="isLoadingEmitir"
          indeterminate
          size="18"
          color="white"
          class="mr-2"
        />
        </v-btn>
      </template>

    </v-card-actions>

    <v-snackbar v-model="snack" :timeout="3500" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Fechar</v-btn>
    </v-snackbar>
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="dialogError" max-width="500">
          <v-card class="text-center">
            <v-card-title class="primary">
              <span class="headline">ERRO PARA EMITIR COTAÇÃO</span>
            </v-card-title>

            <h3 class="pa-3 text-xs-center">
              {{ errorMessage }}
            </h3>

            <v-card-text>
              <div
                class="color pa-3"
                v-for="(value, key) in errorDetails"
                :key="key"
              >
                <h4>{{ key }}:</h4>
                <span v-for="(message, index) in value" :key="index">
                  {{ message }}
                </span>
              </div>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="primary darken-1"
                flat="flat"
                @click="dialogError = false"
              >
                Fechar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <v-dialog v-model="dialogRecusa" persintent max-width="550">
      <ModalRecusarCotacao
        @fecharModalRecusa="dialogRecusa = false"
        :idApolice="idApolice != null ? parseInt(idApolice) : 0"
      ></ModalRecusarCotacao>
    </v-dialog>
    <v-dialog persistent v-model="mostrarModalErroChassiDuplicado" max-width="570px">
      <ModalErroChassiExistente
        :mensagemErro = "mensagensErroChassiDuplicado"
        :textoSalvarOuEmitir = "this.textoSalvarOuEmitir"
        :mostrarBotaoSalvarOuEmitir = "true"
        @fecharModalErroChassiExistente="
          mostrarModalErroChassiDuplicado = false;
          $emit('fecharModalErroChassiExistente');
        "
        @emitirOuSalvarPropostaComErros="
          salvarEmitirCotacao(emitirProposta, true, liberarProposta);
          $emit('emitirOuSalvarPropostaComErros');
        ">
      </ModalErroChassiExistente>
    </v-dialog>
    <v-dialog v-model="showConfirm" max-width="520px">
      <ModalConfirmacaoEmissao
        v-model="showConfirm"
        title="Confirmação"
        message="Confirma EMITIR PROPOSTA?"
        confirm-text="EMITIR PROPOSTA"
        cancel-text="CANCELAR"
        @confirm="onDialogConfirm"
        @cancel="onDialogCancel"
      />
    </v-dialog>
    <v-dialog persistent v-model="showSucesso" max-width="400">
      <ModalSucesso
        :visible="showSucesso"
        @close="redirecionar"
      />
    </v-dialog>
    <v-dialog persistent v-model="dialogSalvarCotacao" max-width="520">
      <ModalSalvarCotacao
        :disableButtons="isLoadingSalvar || isLoadingEmitir"
        @apenas-salvar="onApenasSalvar"
        @salvar-e-liberar="onSalvarELiberar"
        @fechar="dialogSalvarCotacao = false"
      />
    </v-dialog>
    <v-dialog persistent v-model="dialogContestar" max-width="560">
      <v-card>
        <v-card-title class="primary">
          <span class="headline">CONTESTAR COTAÇÃO</span>
        </v-card-title>
        <v-card-text>
          <v-textarea
            v-model="justificativaContestacao"
            outline
            rows="4"
            label="Informe a justificativa da contestação"
            :disabled="isLoadingContestar"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            color="primary"
            :disabled="isLoadingContestar"
            @click="fecharDialogContestar"
          >
            Cancelar
          </v-btn>
          <v-btn
            class="button-permanecer"
            flat
            :disabled="!justificativaPreenchida || isLoadingContestar"
            @click="confirmarContestacao"
          >
            Contestar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import ModalRecusarCotacao from "./ModalRecusarCotacao.vue";
import ModalErroChassiExistente from "./ModalErroChassiExistente.vue";
import ModalConfirmacaoEmissao from "./ModalConfirmacaoEmissao.vue";
import ModalSucesso from "./ModalSucesso.vue";
import ModalSalvarCotacao from "./ModalSalvarCotacao.vue";
import statusEndossoEnum from "@/helpers/status-endosso-enum.js";
import statusPropostaEnum from "@/helpers/status-proposta-enum.js";
import statusTratativaHelper from "@/helpers/status-tratativa.js";

const STATUS_TRATATIVA_EDITAVEIS = [13, 14, 15];
const STATUS_PERMITE_CONTESTAR = [8, 1, 13, 14, 15];
const PERFIS_ANALISTA = [1, 4];
const STATUS_CONTESTADA = 15;
export default {
  name: "ModalDeCalculo",
  components: {
    ModalRecusarCotacao,
    ModalErroChassiExistente,
    ModalConfirmacaoEmissao,
    ModalSucesso,
    ModalSalvarCotacao
  },
  data() {
    return {
      dialogRecusa: false,
      mostrarModalErroChassiDuplicado: false,
      mensagensErroChassiDuplicado: null,
      textoSalvarOuEmitir: null,
      emitirProposta: null,
      liberarProposta: null,
      dialogSalvarCotacao: false,
      dialogContestar: false,
      justificativaContestacao: "",
      isLoadingContestar: false,
      menu: false,
      snack: false,
      snackColor: "",
      snackText: "",
      dialogError: false,
      errorMessage: "",
      formType: null,
      errorDetails: null,
      idApolice: null,
      tratativaHabilitada: false,
      listaIdItem: [],
      idEndossoRascunhoSalvo: null,
      idStatusEndosso: null,
      exibirEmitirComErro: false,
      idPropostaStatus: null,
      numeroRevisao: null,
      isLoadingEmitir: false,
      isLoadingSalvar: false,
      showConfirm: false,
      showSucesso: false,
      idTipoCondicao: 1,
      idAplicaCondicao: 4,
      percentualCondicao: null,
      listaCondicaoComercialEspecial: [],
      listaCondicaoComercialEspecialModificacao: [],
      mostrarCamposCondicaoComercialEspecial: false,
      condicaoAlterada: false,
      isLoadingCalcular: false,
      modelosListas: {
        catVeiculoList: []
      },
      tipoCondicaoList: [
        { id: 1, titulo: "Nenhuma" },
        { id: 2, titulo: "Agravo" },
        { id: 3, titulo: " Desconto" }
      ],
      tipoCondicaoFiltrada: [
        { id: 2, titulo: "Agravo" },
        { id: 3, titulo: " Desconto" }
      ],
      aplicCondicaoList: [
        { id: 1, titulo: "Em Todas as coberturas" },
        { id: 2, titulo: "Apenas RCF" },
        { id: 3, titulo: "Apenas Compreensiva" }
      ],
      aplicaCondicaoList: [
        { id: 1, titulo: "Em Todas as coberturas" },
        { id: 2, titulo: "Apenas RCF" },
        { id: 4, titulo: "Nenhuma" }
      ]
    };
  },
  props: {
    dialog: Boolean,
    resultados: Object,
    statusProposta: Boolean,
    camposInfoGerais: Object,
    idStatus: Number,
    mostrarBotaoEmitirModal: Boolean
  },
  computed: {
    textPrimeiraParcela() {
      return new Date(
        this.camposInfoGerais.dataPrimeiraParcela
      ).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    pageEndosso() {
      return this.$route.query.idTipoEndosso;
    },
    visualizarCamposAcoesCalculos() {
      if (this.pageEndosso) {
        return this.idStatusEndosso == null
          || this.idStatusEndosso == statusEndossoEnum.statusEndosso.SALVO
          || this.idStatusEndosso == statusEndossoEnum.statusEndosso.PENDENTE;
      }

      if (this.idPropostaStatus == null) {
        return true;
      }

      return this.idPropostaStatus == statusPropostaEnum.statusProposta.COTACAO
        || this.idPropostaStatus == statusPropostaEnum.statusProposta.PROPOSTA
        || this.idPropostaStatus == statusPropostaEnum.statusProposta.PENDENTE
        || STATUS_TRATATIVA_EDITAVEIS.indexOf(Number(this.idPropostaStatus)) !== -1;
    },
    perfilUsuarioLogado() {
      const usuario = usuarioHelper.USUARIO_LOGADO();
      if (!usuario || !usuario.perfil) return null;
      return Number(usuario.perfil.id);
    },
    ehCorretorParceiro() {
      return this.perfilUsuarioLogado === statusTratativaHelper.PERFIL_CORRETOR_PARCEIRO;
    },
    ehAnalista() {
      return PERFIS_ANALISTA.indexOf(this.perfilUsuarioLogado) !== -1;
    },
    camposDisabled() {
      if (this.ehCorretorParceiro) return true;
      return !this.bloquearCamposCalculos() || !this.visualizarCamposAcoesCalculos;
    },
    mostrarBotaoContestar() {
      if (!this.ehAnalista || this.pageEndosso) return false;
      if (!this.tratativaHabilitada) return false;
      if (!this.idApolice || Number(this.idApolice) === 0) return false;
      return STATUS_PERMITE_CONTESTAR.indexOf(Number(this.idPropostaStatus)) !== -1;
    },
    justificativaPreenchida() {
      return !!(this.justificativaContestacao && this.justificativaContestacao.trim());
    },
    storeNamespace() {
      return this.formType === "E" ? "formEndosso" : "formCotacao";
    },
    namespacePagamento() {
      return ["E", "CE", "CS"].includes(this.formType)
        ? "formEndosso"
        : "formCotacao";
    },
    mostrarCondicoesComerciais() {
      if (this.formType === "C") return true;
      if (this.formType === "E") return Number(this.pageEndosso) === 1;
      return false;
    },
    condicoesDesabilitadas() {
      return !this.visualizarCamposAcoesCalculos || this.ehCorretorParceiro;
    },
    percCondicaoComercial: {
      get() {
        switch (this.idTipoCondicao) {
          case 1:
            return 0;
          case 2:
            return +this.percentualCondicao;
          case 3:
            return -this.percentualCondicao;
        }
      },
      set(perc) {
        if (typeof perc === "number") {
          if (perc === 0) {
            this.idTipoCondicao = this.tipoCondicaoList[0].id;
          } else {
            this.percentualCondicao = Math.abs(perc);
            this.idTipoCondicao = this.tipoCondicaoList[perc > 0 ? 1 : 2].id;
          }
        }
      }
    }
  },

  watch: {
    listaCondicaoComercialEspecial(newVal) {
      if (newVal.length > 0) {
        this.idTipoCondicao = 1;
        this.percentualCondicao = null;
      }
    },
    idTipoCondicao(newVal) {
      if (newVal == 1) {
        this.idAplicaCondicao = 4;
        this.percentualCondicao = 0;
      }
    }
  },

  mounted() {
    this.idStatusEndosso = this.parseIntQueryParam(this.$route.query.idStatusEndosso);
    if (this.$store.getters["formEndosso/infoEndosso"].idEndossoRascunhoSalvo) {
      this.idEndossoRascunhoSalvo = this.$store.getters[
        "formEndosso/infoEndosso"
      ].idEndossoRascunhoSalvo;
    }
    this.numeroRevisao = this.$route.query.numeroRevisao ? this.$route.query.numeroRevisao : null;
    this.idApolice = this.$route.query.id ? this.$route.query.id : 0;
    this.idPropostaStatus = this.$route.query.idPropostaStatus
        ? this.$route.query.idPropostaStatus
        : null;
    this.formType = {
      "/GridPrincipal/CoberturaEndosso": "E",
      "/GridPrincipal/Cobertura": "C",
      "/GridPrincipal/CoberturaEndossoExclusao": "CE",
      "/GridPrincipal/CoberturaEndossoSubstituicao": "CS"
    }[this.$route.path];

    this.buscaOpcoesCalculo();
    this.inicializarCondicoes();
    this.buscaOpcoesTipoVeiculo();
    this.carregarSituacaoTratativa();
  },
  methods: {
    parseIntQueryParam(param) {
      if (param) {
        return parseInt(param);
      }
      return null;
    },

    inicializarCondicoes() {
      const info = this.formType === "E"
        ? this.$store.getters["formEndosso/infoEndosso"]
        : this.$store.getters["formCotacao/infoGerais"];

      const perc = info.percCondicaoComercial;
      if (info.idTipoCondicao != null) {
        this.idTipoCondicao = info.idTipoCondicao;
      } else if (perc > 0) {
        this.idTipoCondicao = 2;
      } else if (perc < 0) {
        this.idTipoCondicao = 3;
      } else {
        this.idTipoCondicao = 1;
      }
      this.idAplicaCondicao = info.idAplicaCondicao != null ? info.idAplicaCondicao : 4;
      this.percentualCondicao = perc != null ? Math.abs(perc) : null;

      const lista = info.listaCondicaoComercialEspecial;
      this.listaCondicaoComercialEspecial = Array.isArray(lista)
        ? JSON.parse(JSON.stringify(lista))
        : [];
      const listaMod = info.listaCondicaoComercialEspecialModificacao;
      this.listaCondicaoComercialEspecialModificacao = Array.isArray(listaMod)
        ? JSON.parse(JSON.stringify(listaMod))
        : [];
      this.mostrarCamposCondicaoComercialEspecial =
        this.listaCondicaoComercialEspecial.length > 0;

      this.$nextTick(() => {
        this.condicaoAlterada = false;
      });
    },

    buscaOpcoesTipoVeiculo() {
      axios
        .get(`${process.env.URL_PLANILHAMS}/v1/buscarOpcoesCampos/`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          ["catVeiculoList"].forEach(nome => {
            this.modelosListas[nome] =
              response.data[nome] instanceof Array ? response.data[nome] : [];
          });
        })
        .catch(err => {
          console.error(err);
        });
    },

    adicionarNovaCondicaoComercialEspecial() {
      this.mostrarCamposCondicaoComercialEspecial = true;
      this.condicaoAlterada = true;
      this.listaCondicaoComercialEspecial.push({
        id: null,
        idApolice: null,
        idTipoCondicao: null,
        idAplicaCondicao: null,
        percCondicaoComercial: null,
        listaIdCategoriaVeiculo: []
      });
    },

    removerCondicaoComercialEspecial(index) {
      this.condicaoAlterada = true;
      if (this.listaCondicaoComercialEspecial[index].id !== null) {
        const itemRemovido = this.listaCondicaoComercialEspecial[index];
        this.listaCondicaoComercialEspecial.splice(index, 1);
        if (!this.listaCondicaoComercialEspecialModificacao) {
          this.listaCondicaoComercialEspecialModificacao = [];
        }
        this.listaCondicaoComercialEspecialModificacao.push(itemRemovido);
      } else {
        this.listaCondicaoComercialEspecial.splice(index, 1);
      }
    },

    igualTodosItensCategoriaVeiculo(index) {
      return this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.length === this.modelosListas.catVeiculoList.length
        || this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.length > this.modelosListas.catVeiculoList.length;
    },

    igualUmItemCategoriaVeiculo(index) {
      return (
        this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.length > 0 && !this.igualTodosItensCategoriaVeiculo(index)
      );
    },

    iconeSelecionarTodosCategoriaVeiculo(index) {
      if (this.igualTodosItensCategoriaVeiculo(index)) return "check_box";
      if (this.igualUmItemCategoriaVeiculo(index)) return "indeterminate_check_box";
      return "indeterminate_check_box";
    },

    selecionarTodosItensCategoriaVeiculo(index) {
      this.condicaoAlterada = true;
      this.$nextTick(() => {
        if (this.igualTodosItensCategoriaVeiculo(index)) {
          this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo = [];
        } else {
          const listagemItensVeiculos = this.modelosListas.catVeiculoList.slice();
          for (var veiculoItem of listagemItensVeiculos) {
            if (!this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.includes(veiculoItem.id)) {
              this.listaCondicaoComercialEspecial[index].listaIdCategoriaVeiculo.push(veiculoItem.id);
            }
          }
        }
      });
    },

    marcarCondicaoAlterada() {
      this.condicaoAlterada = true;
    },

    comitarCondicoes() {
      this.$store.commit(`${this.storeNamespace}/setCondicaoComercial`, {
        idTipoCondicao: this.idTipoCondicao,
        idAplicaCondicao:
          this.idAplicaCondicao == null ? 4 : this.idAplicaCondicao,
        percCondicaoComercial: this.percCondicaoComercial,
        listaCondicaoComercialEspecial: this.listaCondicaoComercialEspecial,
        listaCondicaoComercialEspecialModificacao: this.listaCondicaoComercialEspecialModificacao
      });
    },

    percentualParaNumero(valor) {
      if (valor === null || valor === undefined || valor === "") {
        return null;
      }
      if (typeof valor === "number") {
        return valor;
      }
      const numero = Number(String(valor).trim().replace(",", "."));
      return Number.isNaN(numero) ? null : numero;
    },

    comitarDadosPagamento() {
      this.$store.commit(`${this.namespacePagamento}/setDadosPagamento`, {
        dataPrimeiraParcela: this.camposInfoGerais.dataPrimeiraParcela,
        idParcelamento: this.camposInfoGerais.idParcelamento,
        idFormaPagamento: this.camposInfoGerais.idFormaPagamento,
        apoliceIof: this.percentualParaNumero(this.camposInfoGerais.apoliceIof),
        corretagem: this.percentualParaNumero(this.camposInfoGerais.corretagem)
      });
    },

    async calcular() {
      this.comitarDadosPagamento();
      this.comitarCondicoes();
      this.isLoadingCalcular = true;
      this.$emit("ativarLoader");
      try {
        let path;
        let requestBody;
        if (this.formType === "E") {
          requestBody = {
            ...this.$store.getters["formEndosso/requisicaoEndossoAdicionar"],
            listaCondicaoComercialEspecial: this.$store.getters["formEndosso/infoEndosso"].listaCondicaoComercialEspecial,
            listaCondicaoComercialEspecialModificacao: this.$store.getters["formEndosso/infoEndosso"].listaCondicaoComercialEspecialModificacao
          };
          path = `${process.env.URL_ENDOSSOMS}/v1/calcularEndosso/${this.idApolice}`;
        } else {
          requestBody = this.$store.getters["formCotacao/conteudoCalculoPlanilha"];
          requestBody.gatilhoEstipulado = this.$store.getters["formCotacao/conteudoSalvarCotacao"].gatilhoEstipulado;
          requestBody.listaCondicaoComercialEspecial = this.$store.getters["formCotacao/infoGerais"].listaCondicaoComercialEspecial;
          path = `${process.env.URL_CALCULOMS}/v1/calcularProposta`;
        }

        const response = await axios.post(path, requestBody, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        });
        Object.assign(this.resultados, response.data);
        this.condicaoAlterada = false;
      } catch (error) {
        this.snack = true;
        this.snackColor = "error";
        const data = error && error.response && error.response.data;
        this.snackText = (data && data.message) || "Erro ao recalcular.";
        throw error;
      } finally {
        this.isLoadingCalcular = false;
        this.$emit("desativarLoader");
      }
    },
    bloquearCamposCalculos() {
      let endossoAtual = this.$store.getters["formEndosso/infoEndosso"];
      if (this.idPropostaStatus != null && this.idPropostaStatus == 7) {
        return false;
      }
      if (this.numeroRevisao == null) {
        return true;
      }

      if (!Number.isNaN(endossoAtual.idStatusEndosso) && endossoAtual.idStatusEndosso == 1) {
        return true;
      }
    },

    fecharDialogErro() {
      this.dialogError = false;
      this.exibirEmitirComErro = false;
    },
    buscaOpcoesCalculo() {
      ["formaPagamento", "parcelamento"].forEach(item => {
        axios
          .get(`${process.env.URL_APOLICEMS}/v1/${item}`, {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          })
          .then(response => {
            this.camposInfoGerais[`${item}List`] =
              response.data instanceof Array ? response.data : [];
          })
          .catch(err => {
            console.error(err);
          });
      });
      if (this.formType === "E") {
        var store = this.$store.state.formEndosso;
      } else if (this.formType === "CE") {
        var dadosEndosso = this.$store.getters["formEndosso/dadosEndosso"];
        this.$store.state.formEndosso.idParcelamento =
          dadosEndosso.idParcelamento;
        this.$store.state.formEndosso.dataPrimeiraParcela =
          dadosEndosso.dataPrimeiraParcela;
        this.$store.state.formEndosso.idFormaPagamento =
          dadosEndosso.idFormaPagamento;
        store = this.$store.state.formEndosso;
      } else if (this.formType === "CS") {
        var dadosEndosso = this.$store.getters["formEndosso/dadosEndosso"];
        this.$store.state.formEndosso.idParcelamento =
          dadosEndosso.idParcelamento;
        this.$store.state.formEndosso.dataPrimeiraParcela =
          dadosEndosso.dataPrimeiraParcela;
        this.$store.state.formEndosso.idFormaPagamento =
          dadosEndosso.idFormaPagamento;
        store = this.$store.state.formEndosso;
      } else {
        store = this.$store.state.formCotacao;
      }
      this.camposInfoGerais.idParcelamento = store.idParcelamento;
      this.camposInfoGerais.idFormaPagamento = store.idFormaPagamento;
      this.camposInfoGerais.apoliceIof = store.apoliceIof;
      this.camposInfoGerais.corretagem = store.corretagem;
      this.camposInfoGerais.dataPrimeiraParcela = store.dataPrimeiraParcela;
    },

    voltar: function() {
      this.$router.back();
    },

    listarItemRemovidos() {
      let endossoDoTipoExclusao = this.$store.getters["formEndosso/infoEndosso"].idTipoEndosso === 3;
      let itensExclusao = null;
      let itemRemovidoList = [];
      if (this.idStatusEndosso == 1 && this.idEndossoRascunhoSalvo && !endossoDoTipoExclusao) {
        itensExclusao = this.$store.getters["formEndosso/dadosItensRestantes"];
        for (var item of itensExclusao.itensRestantes) {
          itemRemovidoList.push(item.item);
        }
      } else {
        itensExclusao = this.$store.getters["formEndosso/dadosItemExclusao"];
        if (itensExclusao.itemRemovidoList.length > 0) {
          for (var item of itensExclusao.itemRemovidoList) {
            itemRemovidoList.push(item);
          }
        }
      }

      return itemRemovidoList;
    },

    objetoEndossoExclusao() {
      let dadosEndosso = this.$store.getters["formEndosso/dadosEndosso"];
      let itensModficados = this.$store.getters[
        "formEndosso/setItensModificados"
      ];
      let infoEndosso = this.$store.getters["formEndosso/infoEndosso"];
      let endossoExclusao = {
        idUsuario: usuarioHelper.USUARIO_LOGADO().idUsuario,
        nomeUsuario: usuarioHelper.USUARIO_LOGADO().nome,
        idMotivoEndosso: dadosEndosso.idMotivoEndosso,
        textoLivreEndosso: dadosEndosso.textoLivreEndosso,
        dateInicio: dadosEndosso.dateInicio,
        proponenteCnpj: dadosEndosso.proponenteCnpj,
        proponenteRazaoSocial: dadosEndosso.proponenteRazaoSocial,
        idTipoEndosso: this.$route.query.idTipoEndosso,
        idTipoPessoa: dadosEndosso.idTipoPessoa,
        itemRemovidoList: this.listarItemRemovidos(),
        itemModificadoList: itensModficados.itemModificadoList,
        idEndossoRascunhoSalvo: this.idEndossoRascunhoSalvo,
        totaisCotacao: this.resultados,
        idTecnicoResponsavelEndosso: infoEndosso.idTecnicoResponsavelEndosso,
        nomeTecnicoResponsavelEndosso: infoEndosso.nomeTecnicoResponsavelEndosso,
        idCorretorResponsavelEndosso: infoEndosso.idCorretorResponsavelEndosso,
        nomeCorretorResponsavelEndosso: infoEndosso.nomeCorretorResponsavelEndosso
      };

      return endossoExclusao;
    },

    formatarPrimeiraParcela(data) {
      return new Date(data).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    formatMoney(amount) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL"
      }).format(amount || 0);
    },

    carregarSituacaoTratativa() {
      if (this.formType !== "C") {
        this.tratativaHabilitada = false;
        return;
      }
      if (!this.idApolice || Number(this.idApolice) === 0) {
        this.tratativaHabilitada = true;
        return;
      }
      axios
        .post(
          `${process.env.URL_TRATATIVAMS}/v1/resumo`,
          { idsApolice: [parseInt(this.idApolice)] },
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          const resumo = (response.data instanceof Array ? response.data : [])[0];
          this.tratativaHabilitada = !!resumo;
        })
        .catch(() => {
          this.tratativaHabilitada = false;
        });
    },

    salvarCotacao() {
      if (this.formType === "C" && this.tratativaHabilitada) {
        this.dialogSalvarCotacao = true;
        return;
      }
      return this.executarSalvarCotacao(null);
    },

    onApenasSalvar() {
      this.dialogSalvarCotacao = false;
      this.executarSalvarCotacao(false);
    },

    onSalvarELiberar() {
      this.dialogSalvarCotacao = false;
      this.executarSalvarCotacao(true);
    },

    async executarSalvarCotacao(liberar) {
      if (this.condicaoAlterada) {
        try {
          await this.calcular();
        } catch (e) {
          return;
        }
      }
      this.enviar(false, liberar);
    },

    async emitirCotacao() {
      if (this.condicaoAlterada) {
        try {
          await this.calcular();
        } catch (e) {
          return;
        }
      }
      this.enviar(true);
    },

    salvarEmitirCotacao(emitir, ignorarErros, liberar) {
      this.comitarDadosPagamento();
      const getPayloadAndPath = () => {
        const baseUrl = process.env.URL_ENDOSSOMS;
        let payload, path;

        switch (this.$route.path) {
          case "/GridPrincipal/CoberturaEndossoExclusao":
            payload = this.objetoEndossoExclusao();
            payload.ignorarErrosReservaMercado = ignorarErros;
            path = `${baseUrl}/v1/${emitir ? "emitir" : "salvar"}Endosso/${
              this.idApolice
            }`;
            break;

          case "/GridPrincipal/CoberturaEndosso":
            payload = this.$store.getters["formEndosso/conteudoSalvarEndosso"];
            payload.totaisCotacao = this.resultados;
            payload.idEndossoRascunhoSalvo = this.idEndossoRascunhoSalvo;
            payload.ignorarErrosReservaMercado = ignorarErros;
            path = `${baseUrl}/v1/${
              emitir
                ? "emitir"
                : "salvar"
            }Endosso/${this.idApolice}`;
            break;

          case "/GridPrincipal/CoberturaEndossoSubstituicao":
            payload = this.objetoModificado();
            payload.totaisCotacao = this.resultados;
            path = `${baseUrl}/v1/${emitir ? "emitir" : "salvar"}Endosso/${
              this.idApolice
            }`;
            payload.ignorarErrosReservaMercado = ignorarErros;
            break;

          default:
            payload = this.$store.getters["formCotacao/conteudoSalvarCotacao"];
            payload.totaisCotacao = this.resultados;
            payload.apoliceCopiada = this.$route.query.apoliceCopiada;
            payload.ignorarErrosReservaMercado = ignorarErros;

            path = `${process.env.URL_CALCULOMS}/v1/${
              emitir ? "emitir" : "salvarPrimeiraVez"
            }Proposta`;
            if (!emitir && typeof liberar === "boolean") {
              path = `${path}?liberar=${liberar}`;
            }
            break;
        }

        return [payload, path];
      };

      const [payload, path] = getPayloadAndPath();
      if(emitir){
        this.isLoadingEmitir = true;
      } else {
        this.isLoadingSalvar = true;
      }

      axios
        .post(path, payload, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then((response) => {
          this.$emit("desativarLoader");
          this.save(emitir);
          this.isLoadingEmitir = false;
          this.isLoadingSalvar = false;
        })
        .catch(error => {
          this.isLoadingEmitir = false;
          this.isLoadingSalvar = false;
          this.$emit("desativarLoader");
          const data = error && error.response && error.response.data;

          this.errorMessage =
            (data && (data.erros || data.message)) ||
            "Ocorreu um erro inesperado.";

          this.dialogError = true;
        });
    },

    verificarSeExisteChassiDuplicado(jsonListaVeiculos, emitir, liberar) {
      const formData = new FormData();
      formData.append("jsonListaVeiculos", JSON.stringify(jsonListaVeiculos));
      formData.append("idApolice", this.idApolice)

      axios
        .post(`${process.env.URL_PLANILHAMS}/v1/encontrarErrosListaVeiculos`, formData, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then((response) => {
          if (response.status == 200) {
            if(emitir){
              this.showConfirm = true;
            } else {
              this.salvarEmitirCotacao(emitir, false, liberar)
            }
          }
          this.$emit("desativarLoader");
        })
        .catch(error => {
          this.mensagensErroChassiDuplicado = error.response.data.message;
          this.mostrarModalErroChassiDuplicado = true;
          this.textoSalvarOuEmitir = emitir ? 'EMITIR' : 'SALVAR';

          this.emitirProposta = emitir;
          this.liberarProposta = typeof liberar === "boolean" ? liberar : null;
          this.isLoadingEmitir = false;
          this.isLoadingSalvar = false;
          this.$emit("desativarLoader");
        });

    },

    enviar(emitir, liberar) {
      this.$emit("ativarLoader");
      if(this.isLoadingEmitir || this.isLoadingSalvar) return;

      if(emitir) {
        this.isLoadingEmitir = true;
      } else {
        this.isLoadingSalvar = true;
      }

      if (this.formType === "CE" || this.formType === "CS") {
        this.salvarEmitirCotacao(emitir, false, liberar);
      } else {
        let listaVeiculosModificados = this.$store.getters["formEndosso/cloneItemAdicionadoList"]
        let veiculosAtuais = listaVeiculosModificados.length > 0
          ? listaVeiculosModificados
          : this.$store.getters["formCotacao/conteudoSalvarCotacao"].conteudoPlanilha;

        this.verificarSeExisteChassiDuplicado(veiculosAtuais, emitir, liberar);
      }

      this.$emit("desativarLoader");
    },

    openConfirm() {
      if (this.isLoadingEmitir || this.isLoadingSalvar) return;
      this.showConfirm = true;
    },

    onDialogCancel() {
      this.showConfirm = false;
    },

    onDialogConfirm() {
      this.salvarEmitirCotacao(true, false)
    },

    abrirDialogContestar() {
      this.justificativaContestacao = "";
      this.dialogContestar = true;
    },

    fecharDialogContestar() {
      this.dialogContestar = false;
      this.justificativaContestacao = "";
    },

    async confirmarContestacao() {
      if (!this.justificativaPreenchida || this.isLoadingContestar) return;

      this.isLoadingContestar = true;
      try {
        const formData = new FormData();
        formData.append("justificativa", this.justificativaContestacao.trim());

        await axios.post(
          `${process.env.URL_TRATATIVAMS}/v1/contestar/${parseInt(this.idApolice)}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        );

        this.idPropostaStatus = STATUS_CONTESTADA;
        this.fecharDialogContestar();
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Cotação contestada com sucesso";
        this.$emit("cotacaoContestada", STATUS_CONTESTADA);
        setTimeout(() => {
          this.redirecionar();
        }, 1500);
      } catch (error) {
        const data = error && error.response && error.response.data;
        this.snack = true;
        this.snackColor = "error";
        this.snackText =
          (data && (data.message || data.erros)) ||
          (error && error.message) ||
          "Não foi possível contestar esta cotação";
      } finally {
        this.isLoadingContestar = false;
      }
    },

    processarRecusar() {
      if (this.pageEndosso) {
        this.$emit("ativarLoader");

        axios
          .put(
            `${process.env.URL_ENDOSSOMS}/v1/recusarEndossoCorretor/${this.idEndossoRascunhoSalvo}`,
            {},
            {
              headers: {
                Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
              }
            }
          )
          .then(response => {
            this.snack = true;
            this.snackColor = "success";
            this.snackText = response.data;
            setTimeout(() => {
              this.fechar();
              this.$router.push(
                "/GridPrincipal/InfoGerais/GridEndossos?id=" + this.idApolice
              );
            }, 2000);
          })
          .catch(err => {
            this.$emit("desativarLoader");
            this.snack = true;
            this.snackColor = "error";
            this.snackText = "Não foi possivel recusar o endosso";
          });
      } else {
        this.dialogRecusa = true;
      }
    },
    objetoModificado() {
      let itensModificados = this.$store.getters[
        "formEndosso/conteudoSalvarEndosso"
      ];
      itensModificados.idEndossoRascunhoSalvo = this.idEndossoRascunhoSalvo;
      if (itensModificados.idTipoEndosso === 5) {
        let listaVeiculosModificados = itensModificados.itemModificadoList;

        let itensModificadosCopia = Object.assign({}, itensModificados);
        let listaVeiculosModificadosCopia = listaVeiculosModificados.map(it =>
          Object.assign({}, it)
        );
        itensModificadosCopia.itemModificadoList = listaVeiculosModificadosCopia;
        for (var veiculoModificado of listaVeiculosModificadosCopia) {
          var propriedades = Object.keys(veiculoModificado);
          for (var propriedade of propriedades) {
            if (propriedade === "vlrFranquiaGarantiaUnica") {
              var value = veiculoModificado[propriedade];
              if (value != null && value != undefined && value === 0) {
                veiculoModificado[propriedade] = null;
              }
              if (value != null && value != undefined && value) {
                veiculoModificado[propriedade] = value;
              }
            } else if (propriedade === "vlrFranquiaDanosMateriais") {
              var value = veiculoModificado[propriedade];
              if (value != null && value != undefined && value === 0) {
                veiculoModificado[propriedade] = null;
              }
              if (value != null && value != undefined && value) {
                veiculoModificado[propriedade] = value;
              }
            } else if (propriedade === "kmAssistencia") {
              if (value != null && value != undefined && value === 0) {
                veiculoModificado[propriedade] = value;
              }
            } else {
              var value = veiculoModificado[propriedade];
              if (value != null && value != undefined && value.id === 0) {
                veiculoModificado[propriedade] = null;
              }
              if (value != null && value != undefined && value.id) {
                veiculoModificado[propriedade] = value.id;
              }
            }
          }
        }
        return itensModificadosCopia;
      } else {
        return this.$store.getters["formEndosso/conteudoSalvarEndosso"];
      }
    },

    redirecionar() {
      this.fechar();
      const routePath = this.pageEndosso
        ? `/GridPrincipal/InfoGerais/GridEndossos?id=${this.idApolice}&idPropostaStatus=${this.idPropostaStatus}`
        : "/GridPrincipal";
      this.$router.push(routePath);
    },

    fechar() {
      this.$emit("fechar");
    },

    save(emitir) {
      if(emitir) {
        this.showSucesso = true;
      } else {
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Item salvo";

        setTimeout(() => {
            this.fechar();
            const routePath = this.pageEndosso
              ? `/GridPrincipal/InfoGerais/GridEndossos?id=${this.idApolice}&idPropostaStatus=${this.idPropostaStatus}`
              : "/GridPrincipal";
            this.$router.push(routePath);
          }, 1000);
      }
    },

    saveStatus() {
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Cotação recusada com sucesso";
    }
  }
};
</script>

<style scoped>
.color {
  background-color: #eaeaea;
}
.button-permanecer .red {
  background-color: red;
}

.v-btn .v-progress-circular {
  vertical-align: middle;
}

.button-permanecer[disabled],
.button-permanecer.v-btn--disabled {
  background-color: rgba(0, 0, 0, .12) !important;
  color: rgba(0, 0, 0, .26) !important;
  opacity: 1 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/pages/frota/ModalDeCalculo.vue